import axios from '@/utils/request'

export default {
  // 2020-09-04
  createMms(params) {
    return axios.post('/mms/user-auths', params)
  },
  // 2020-09-04
  createMes(params) {
    return axios.post('/mes/user-auths', params)
  },
  //2020-07-23
  findByIdMms(id) {
    return axios.get('/mms/user-auths/' + id)
  },
  //2020-07-23
  findByIdMes(id) {
    return axios.get('/mes/user-auths/' + id)
  }

}

